'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldWrapper = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _FieldWrapper = require('./FieldWrapper.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldWrapper = exports.FieldWrapper = function FieldWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      description = _ref.description,
      error = _ref.error,
      label = _ref.label,
      labelFor = _ref.labelFor,
      wrapperProps = _ref.wrapperProps;
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: 'field ' + className }, wrapperProps),
    label &&
    // eslint-disable-next-line
    _react2.default.createElement(
      'label',
      { htmlFor: labelFor },
      label
    ),
    description && null,
    _react2.default.createElement(
      'div',
      { className: 'children' },
      children
    ),
    error && _react2.default.createElement(
      'div',
      { className: 'error' },
      error
    )
  );
};

FieldWrapper.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  description: _propTypes2.default.string,
  error: _propTypes2.default.string,
  label: _propTypes2.default.string,
  labelFor: _propTypes2.default.string,
  wrapperProps: _propTypes2.default.object
};
FieldWrapper.defaultProps = {};

exports.default = (0, _glamorous2.default)(FieldWrapper)(_FieldWrapper.defaultStyle, _FieldWrapper.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/FieldWrapper/FieldWrapper.js
// module id = 17
// module chunks = 0